/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import URLs from '../utilities/URLs';

export async function getMachines() {
  const response = await fetch(URLs.getMachineList());
  const data = await response.json();
  return data;
}
